<div class="row">
  <div class="col-12 d-flex">
    <div class="card flex-fill border-0 bg-white shadow-lg">
      <div class="card-body pt-2 pb-2">
        <h4 class="mb-2 font-bold">Resumo das Estações</h4>
        <div class="row g-2 mb-0">
          <!-- Card 1 - Estações Sem Comunicação -->
          <div class="col-md-4">
            <app-dashboard-metric-card
              titleCard="Sem comunicação"
              [value]="
                (connectionIssuesCount !== undefined &&
                connectionIssuesCount !== null
                  ? connectionIssuesCount
                  : 0
                ).toString()
              "
              description="Não estão enviando dados"
              type="primary"
              buttonLabel="Verificar Estações"
              buttonRoute="/estacoes/monitoramento"
              [isLoading]="isLoadingConnectionIssues"
              [useConditionalColor]="true"
            >
            </app-dashboard-metric-card>
          </div>

          <!-- Card 2 - Estações com Dados Faltantes -->
          <div class="col-md-4">
            <app-dashboard-metric-card
              titleCard="Dados faltantes por dia"
              [value]="missingDataCount.toString()"
              description="Necessitam de atenção"
              type="primary"
              buttonLabel="Verificar Dados"
              buttonRoute="/estacoes/gerenciar-dados-faltantes"
              [isLoading]="isLoadingMissingData"
              [useConditionalColor]="true"
            >
            </app-dashboard-metric-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
